export const headers = [
  { text: 'Top', visible: 'none' },
  { text: 'Nome' },
  { text: 'Vendas Pagas' },
  { text: 'Cancelados' },
  { text: 'Pix em Aberto' },
  { text: 'Relógio' },
  { text: 'Diferença p/ Relógio' },
  { text: 'Meta' },
  { text: 'Diferença p/ Meta' },
  { text: 'Valor 1⁠ª Parcela' },
  { text: 'Projeções Futuras' },
  { text: '' },
];

export const headersModal = [
  'Nome',
  'Vendas Pagas',
  'Cancelados',
  'Pix em Aberto',
  'Relógio',
  'Diferença p/ Relógio',
  'Meta',
  'Diferença p/ Meta',
  'Valor 1⁠ª Parcela',
  'Projeções Futuras',
];

export const data = [
  'João Victor Pires',
  'André Porto',
  'Samuel Santos Alves',
  'Alberto Timóteo',
  'Júlia Totta',
  'Marcelo Gomes',
  'Thiago Menezes',
  'Wallysson Couto',
  'João Victor Martins',
  'Lívia Barros',
  'Renato Christian',
].map((nome) => ({
  nome,
  totalVendas: Math.floor(Math.random() * 21) + 30, // Gera um número entre 30 e 50
  indicadorParcela: `${Math.floor(Math.random() * 3) + 1}`.padStart(2, '0'), // Gera um número entre 1 e 3 e formata como '01', '02', '03'
  relogio: Math.floor(Math.random() * 16) + 35, // Gera um número entre 35 e 50
  diferencaMeta: Math.floor(Math.random() * 16) + 60, // Gera um número entre 60 e 75
  ticketMedio: `R$ ${(Math.random() * 101 + 200).toFixed(2).replace('.', ',')}`, // Gera um valor entre 'R$ 200,00' e 'R$ 300,00'
}));
